/**
 * Standard cost field names that support multi-currency enrichment
 */
export const COST_FIELDS = ['BilledCost', 'EffectiveCost', 'AdjustedCashCost', 'AdjustedAmortizedCost'] as const;

export type CostField = (typeof COST_FIELDS)[number];

/**
 * Check if a field name is a cost field
 */
export function isCostField(fieldName: string): boolean {
    return COST_FIELDS.includes(fieldName as CostField);
}

/**
 * Check if a field is a currency-enriched cost field (e.g., BilledCost-INR)
 */
export function isCurrencyEnrichedField(field: string): boolean {
    const parts = field.split('-');
    if (parts.length !== 2) {
        return false;
    }

    const [baseField, currencyCode] = parts;

    // Check if it's a known cost field and currency code is 3 uppercase letters
    return isCostField(baseField) && currencyCode.length === 3 && /^[A-Z]{3}$/.test(currencyCode);
}
